/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type BackgroundColorPickerContainer_user$ref = any;
type BackgroundCustomImagePickerContainer_user$ref = any;
type BackgroundImagePickerContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BackgroundSettingsContainer_user$ref: FragmentReference;
export type BackgroundSettingsContainer_user = {|
  +id: string,
  +backgroundOption: ?string,
  +customImage: ?string,
  +backgroundColor: ?string,
  +backgroundImage: ?{|
    +imageURL: ?string
  |},
  +$fragmentRefs: BackgroundImagePickerContainer_user$ref & BackgroundColorPickerContainer_user$ref & BackgroundCustomImagePickerContainer_user$ref,
  +$refType: BackgroundSettingsContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BackgroundSettingsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "backgroundOption",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "customImage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "backgroundColor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "backgroundImage",
      "storageKey": null,
      "args": null,
      "concreteType": "BackgroundImage",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageURL",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "BackgroundImagePickerContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "BackgroundColorPickerContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "BackgroundCustomImagePickerContainer_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a05ac9eba9ccf79cfd07d7a6feebad97';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Background/__generated__/BackgroundSettingsContainer_user.graphql.js